const
  NAME               = 'deactivateTabsResolution',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME]
;

const _window$ = $(window);

/**
 * This plugin remove the 'active' class of tabs when the window width
 * is smaller than or equals the width provided in 'data-voc-deactivate-tabs-resolution'
 * attribute, and add this class when the window width is greater
 */
class DeactivateTabsResolution {
  constructor(element$) {
    this._element$ = element$;

    var elementAttr$ = this._element$.data().vocDeactivateTabsResolution;

    if(elementAttr$ !== '') {
      var attrArray$   = elementAttr$.split(';'),
          widthArray$  = attrArray$[0].split(':');

      this._maxWindowWidth = parseInt(widthArray$[1]);
      this.lastWith = window.innerWidth;

      _window$.on('resize', (/*event*/) => this.onResize());

      _window$.resize();
    }
  }

  onResize(/*event*/) {
    this._windowWidth = window.innerWidth;

    // NOTE: To change the class only when there is a jump of _maxWindowWidth
    if ((this._windowWidth <= this._maxWindowWidth && this.lastWith > this._maxWindowWidth) ||
        (this._windowWidth > this._maxWindowWidth  && this.lastWith <= this._maxWindowWidth)) {
      var tabActiveBtn$  = this._element$.find('.nav-pills li.active'),
          tabActivePane$ = this._element$.find('.tab-content .tab-pane.active');

      if(this._windowWidth <= this._maxWindowWidth) {
        tabActiveBtn$.removeClass('active');
        tabActivePane$.removeClass('active');
      } else {
        if(tabActiveBtn$.length === 0) {
          tabActiveBtn$ = this._element$.find('.nav-pills li').first();
        }

        if(tabActivePane$.length === 0) {
          tabActivePane$ = this._element$.find('.tab-content .tab-pane').first();
        }

        tabActiveBtn$.addClass('active');
        tabActivePane$.addClass('active');
      }
      this.lastWith = this._windowWidth;
    }
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface() {
    return this.each(function() {
      new DeactivateTabsResolution($(this));
    });
  }
}

$.fn[NAME]             = DeactivateTabsResolution._jQueryInterface;
$.fn[NAME].Constructor = DeactivateTabsResolution;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return DeactivateTabsResolution._jQueryInterface;
};

export default DeactivateTabsResolution;



// WEBPACK FOOTER //
// ./src/plugins/deactivate-tabs-resolution.js